import script from "./UpdateClientAccountStatusModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateClientAccountStatusModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__